/*
 * Copyright (c) Dito Technologies LLC
 */

import React from "react";
import {createFragmentContainer} from "react-relay";
import {graphql} from "babel-plugin-relay/macro";
import {
    PieceRendererViewAttributes_note$data
} from "ui/feature/piece-play/common/__generated__/PieceRendererViewAttributes_note.graphql";
import Body from "ui/kit/typography/Body";

interface Props {
    note: PieceRendererViewAttributes_note$data
}

const PieceRendererViewAttributes: React.FC<Props> = ({note}) => {
    return (
        <div>
            <Body>Note ID: {note.note_id}</Body>
            <Body>Bulb ID: {note.bulb_id}</Body>
            <Body>Pitch: {note.pitch_name}</Body>
            <Body>MIDI: {note.midi_number}</Body>
            <Body>Note Start: {note.note_start}</Body>
            <Body>Left Handed: {note.left_handed ? "Play with Left" : "Play with Right"}</Body>
        </div>
    )
}

export default createFragmentContainer(
    PieceRendererViewAttributes,
    {
        note: graphql`
        fragment PieceRendererViewAttributes_note on MusicPieceFileNote {
            note_id
            bulb_id
            midi_number
            pitch_name
            left_handed
            note_start
        }
        `
    }
);